import React from 'react';
import PropTypes from 'prop-types';

function Mailbox({ size, stroke, strokeWidth, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      {...otherProps}
    >
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M3.65,17.35 L12.35,17.35 L12.35,12 C12.35,9.59756134 10.4024387,7.65 8,7.65 C5.59756134,7.65 3.65,9.59756134 3.65,12 L3.65,17.35 Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M12.5,17.35 L20.5,17.35"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="square"
      />
      <path
        d="M8.5,7.65 L15.5,7.65"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="square"
      />
      <path
        d="M16,7.6499939 C18.6402793,7.69360488 20.5337702,9.51909379 20.5337702,12.2875998 C20.5337702,14.1332705 20.5337702,16.037402 20.5337702,17.9999943"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M15.5,11.5 L15.5,3.5"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="square"
      />
      <rect stroke={stroke} strokeWidth={strokeWidth} x="15.5" y="2.5" width="5" height="3" />
      <rect
        stroke={stroke}
        strokeWidth={strokeWidth}
        x="12"
        y="17.3500061"
        width="3"
        height="3.6499939"
      />
    </svg>
  );
}

Mailbox.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Mailbox;
